import { render } from "./ContactDetails.vue?vue&type=template&id=6c8f7440&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"

import "./ContactDetails.vue?vue&type=style&index=0&id=6c8f7440&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8f7440"]])

export default __exports__